import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { useModal } from 'components/modals/ModalContext';
import ListContext from 'components/lists/ListContext';
import { ListRowType } from 'types/ListTypes';
import EnvironmentDeleteModal from './EnvironmentDeleteModal';

/*
 * EnvironmentDeleteIcon.tsx
 * Trash icon in the environment list which opens the environment
 * deletion modal for the row. Only shown for environments the backend
 * marks as deletable, so not for the admin environment, deleted
 * environments or environments with a running subscription.
 */

interface EnvironmentDeleteIconProps {
    row: ListRowType;
}

const EnvironmentDeleteIcon: React.FC<EnvironmentDeleteIconProps> = ({ row }) => {
    const { t } = useTranslation();
    const { initializeModal } = useModal();
    const { refetchList } = useContext(ListContext);

    // Only environments the backend marks as deletable get the delete icon
    if (!row.is_deletable) return null;

    // Open the deletion modal without triggering the row click
    const openDeleteModal = (event: React.MouseEvent) => {
        event.stopPropagation();
        initializeModal(
            <EnvironmentDeleteModal
                environmentId={row.id}
                environmentName={row.name}
                onFinished={refetchList}
            />,
            { modalSize: 'extra-small' }
        );
    };

    return (
        <div className='list-delete-icon tooltip-icon environment-delete-icon'>
            <FontAwesomeIcon
                icon={faTrash}
                className='fas fa-trash'
                style={{ cursor: 'pointer' }}
                onClick={openDeleteModal} />
            <span className='tooltip'>{t('environment.deletion.icon_tooltip')}</span>
        </div>
    );
};

export default EnvironmentDeleteIcon;
